
import { Component, Prop, Vue } from 'vue-property-decorator'

import icons from '@/assets/icons/icons.svg'
@Component({
  name: 'SvgIcon'
})
export default class SvgIcon extends Vue {
  @Prop({ required: true }) name!: string
  @Prop({ default: '12px' }) size!: string
  @Prop({ default: 'currentColor' }) color!: string
  @Prop({ default: 'icon' }) className!: string
  icons: string = icons
}
